export const progressBarStyle = { borderRadius: 5, width: 80, opacity: 0.5, backgroundColor: "#999999" };
